<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';

const props = defineProps({
    viewId: String
});

// Store Access
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// State
const options = ref(undefined);

// Computed Properties
const filters = computed(() => {
    return store.state[props.viewId].filters;
});

const filter = computed(() => {
    return filters.value.find(o => o.columnName === 'courseId');
});

const filterKey = computed(() => {
    return filters.value.map(o => o.columnName).indexOf('courseId');
});

const showArchive = computed(() => {
    return store.state[props.viewId].showArchive;
});

// Writable Computed Property
const courseId = computed({
    get() {
        return parseInt(filter.value?.value) || '';
    },
    set(newCourseId) {
        // If there is no active filter which filters by courseId, then add it.
        if (filterKey.value === -1) {
            const type = 'relationshipOneToMany';
            const option = store.getters['advancedFilters/typesOptions'](type)[0];

            store.dispatch(props.viewId + '/addFilter', {
                columnName: 'courseId',
                type: type,
                condition: option.condition,
                predicate: option.predicate,
                conditionText: option.text
            });
        }

        store.dispatch(props.viewId + '/setFilterProp', {
            key: filterKey.value,
            name: 'value',
            value: newCourseId
        });
    }
});

// Watchers
watch(showArchive, async () => {
    await store.dispatch('odpCourseDatesMenus/courses');
    options.value = store.getters['odpCourseDatesMenus/courses'](showArchive.value);
}, { immediate: true });
</script>

<template>
    <select v-if="options" v-model="courseId" class="form-select form-select-sm w-auto">
        <option v-for="option in options" :key="option.value" :value="option.value">
            {{ option.text }}
        </option>
    </select>
</template>

<style scoped>
select {
    width: 200px !important;
}
</style>